import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/noNewFriend.png'
import _imports_1 from '@/assets/images/matchzbleb.png'


const _withScopeId = n => (_pushScopeId("data-v-bc99248e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"height":"calc(100vh - 138px)"} }
const _hoisted_2 = {
  key: 0,
  class: "nodata"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "subtitle" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "matchKey"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "mathbox-cen" }
const _hoisted_10 = { class: "mathbox-cen-top" }
const _hoisted_11 = { class: "mathbox-cen-top-left" }
const _hoisted_12 = { alt: "" }
const _hoisted_13 = { class: "ovehide p2" }
const _hoisted_14 = { class: "mathbox-cen-top-cen" }
const _hoisted_15 = { style: { color: '#f0082e', } }
const _hoisted_16 = { class: "mathbox-cen-top-right" }
const _hoisted_17 = ["src", "onClick"]
const _hoisted_18 = ["src", "onClick"]
const _hoisted_19 = { class: "mathbox-cen-bottom" }
const _hoisted_20 = { class: "mathbox-cen-bottom-box" }
const _hoisted_21 = { class: "mathbox-cen-bottom-cent zyjuz_j" }
const _hoisted_22 = { class: "mathbox-cen-bottom-cent-box jyou" }
const _hoisted_23 = { class: "ovehide name" }
const _hoisted_24 = { class: "cent_" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "symbol" }, " - ", -1 /* HOISTED */))
const _hoisted_28 = { class: "mathbox-cen-bottom-cent-box jzuo" }
const _hoisted_29 = { class: "ovehide name" }
const _hoisted_30 = ["src"]
const _hoisted_31 = {
  key: 0,
  class: "mathbox_bottom"
}
const _hoisted_32 = {
  key: 0,
  class: "card red"
}
const _hoisted_33 = {
  key: 1,
  class: "card yellow"
}
const _hoisted_34 = { key: 2 }
const _hoisted_35 = { key: 3 }
const _hoisted_36 = {
  key: 4,
  class: "card yellow"
}
const _hoisted_37 = {
  key: 5,
  class: "card red"
}
const _hoisted_38 = { class: "mathbox_bottom" }
const _hoisted_39 = {
  key: 0,
  class: "liveUserBox"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "matchzbleb",
  src: _imports_1,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_41 = { class: "list" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["src"]
const _hoisted_44 = { class: "van-ellipsis" }
const _hoisted_45 = { style: {"height":"80px","width":"100%","display":"flex","justify-content":"center","padding-top":"5px","font-size":"12px","color":"#969799"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_pull_refresh, {
      modelValue: $setup.loading,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.loading) = $event)),
      onRefresh: $setup.onRefresh,
      "success-text": $setup.t('me.sxcg'),
      "pull-distance": "60",
      style: {"height":"100%"}
    }, {
      default: _withCtx(() => [
        (!$setup.isData && $setup.finished)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('noData.nobifen')), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('noData.noLive')), 1 /* TEXT */)
            ]))
          : (_openBlock(), _createBlock($setup["DynamicScroller"], {
              key: 1,
              items: $setup.dataList,
              "min-item-size": 1,
              class: "msgScroller",
              "emit-update": false,
              ref: "scrollerRef",
              onScrollEnd: $setup.onLoad,
              onUpdate: $setup.onUpdate,
              onScrollStart: $setup.onScrollStart,
              "page-mode": false
            }, {
              default: _withCtx(({ item, index, active }) => [
                _createVNode($setup["DynamicScrollerItem"], {
                  item: item,
                  active: active,
                  "data-index": index
                }, {
                  default: _withCtx(() => [
                    (item.title)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          ($setup.props.name != $setup.t('im.allin'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(item.key), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "mathbox",
                          onClick: ($event: any) => ($setup.toLiveRoom(item))
                        }, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, [
                                _createCommentVNode(" <img :style=\"{ 'width': sersen(item).showGif ? '17px' : '18px', 'height': sersen(item).showGif ? '17px' : '18px' }\" "),
                                _createCommentVNode(" :class=\"{'spin': sersen(item).showGif}\" "),
                                _withDirectives(_createElementVNode("img", _hoisted_12, null, 512 /* NEED_PATCH */), [
                                  [_directive_lazy, item.type_id == 1 ? ($setup.sersen(item).showGif ? $setup.zuqiusGif : $setup.zuqius) : ($setup.sersen(item).showGif ? $setup.lanqiusGif : $setup.lanqius)]
                                ]),
                                _createElementVNode("p", null, [
                                  _createElementVNode("span", null, _toDisplayString($setup.matchListTime(item.match_time)) + "   ", 1 /* TEXT */),
                                  _createElementVNode("span", _hoisted_13, _toDisplayString(item.short_name_zh) + "    ", 1 /* TEXT */)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("span", _hoisted_15, _toDisplayString($setup.sersen(item).subStatus) + " " + _toDisplayString(item.show_time), 1 /* TEXT */),
                                ($setup.sersen(item).status !== '正在直播')
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      style: _normalizeStyle({ color: item.status_id == 8 ? '#B2B2B2' : $setup.sersen(item).statusColor, })
                                    }, _toDisplayString($setup.sersen(item).status), 5 /* TEXT, STYLE */))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _createElementVNode("div", _hoisted_16, [
                                (item.is_follow)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: $setup.yidingyue,
                                      alt: "",
                                      onClick: _withModifiers(($event: any) => ($setup.toDingyue(0, item)), ["stop"])
                                    }, null, 8 /* PROPS */, _hoisted_17))
                                  : (_openBlock(), _createElementBlock("img", {
                                      key: 1,
                                      src: $setup.dingyue_icon,
                                      alt: "",
                                      onClick: _withModifiers(($event: any) => ($setup.toDingyue(1, item)), ["stop"])
                                    }, null, 8 /* PROPS */, _hoisted_18))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("div", _hoisted_21, [
                                  _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("p", _hoisted_23, _toDisplayString(item.home_name), 1 /* TEXT */),
                                    (item.home_log !== '')
                                      ? (_openBlock(), _createBlock(_component_van_image, {
                                          key: 0,
                                          round: "",
                                          fit: "cover",
                                          "lazy-load": "",
                                          src: item.home_log
                                        }, null, 8 /* PROPS */, ["src"]))
                                      : (_openBlock(), _createBlock(_component_van_image, {
                                          key: 1,
                                          round: "",
                                          fit: "cover",
                                          "lazy-load": "",
                                          src: item.type_id == 1 ? $setup.mach_football_icon : $setup.mach_basketball_icon
                                        }, null, 8 /* PROPS */, ["src"]))
                                  ]),
                                  _createElementVNode("div", _hoisted_24, [
                                    (item.status_id == 1)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, " VS "))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_26, [
                                          _createTextVNode(_toDisplayString($setup.Match.getHomeScore(item)) + " ", 1 /* TEXT */),
                                          _hoisted_27,
                                          _createTextVNode(" " + _toDisplayString($setup.Match.getAwayScore(item)), 1 /* TEXT */)
                                        ]))
                                  ]),
                                  _createElementVNode("div", _hoisted_28, [
                                    (item.away_log !== '')
                                      ? (_openBlock(), _createBlock(_component_van_image, {
                                          key: 0,
                                          round: "",
                                          fit: "cover",
                                          "lazy-load": "",
                                          src: item.away_log
                                        }, null, 8 /* PROPS */, ["src"]))
                                      : (_openBlock(), _createBlock(_component_van_image, {
                                          key: 1,
                                          round: "",
                                          fit: "cover",
                                          "lazy-load": "",
                                          src: item.type_id == 1 ? $setup.mach_football_icon : $setup.mach_basketball_icon
                                        }, null, 8 /* PROPS */, ["src"])),
                                    _createCommentVNode(" <van-image fit=\"cover\" lazy-load :src=\"item.away_log\" /> "),
                                    _createElementVNode("p", _hoisted_29, _toDisplayString(item.away_name), 1 /* TEXT */),
                                    ($setup.sersen(item).status == '直播中' && item.nami.length > 0)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 2,
                                          class: "bofang",
                                          src: $setup.bofangicon,
                                          alt: ""
                                        }, null, 8 /* PROPS */, _hoisted_30))
                                      : _createCommentVNode("v-if", true)
                                  ])
                                ])
                              ]),
                              _createCommentVNode(" 足球 "),
                              (item.type_id == 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                    _createCommentVNode(" <p v-if=\"item.type_id == 1\"> "),
                                    (item.home_scores[2] > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(item.home_scores[2]), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true),
                                    (item.home_scores[3] > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(item.home_scores[3]), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true),
                                    ($setup.is_has_history && item.zhishu && item.zhishu[0])
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString($setup.getZhishuStr(item.zhishu[0][2])), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('match.ban')) + ":" + _toDisplayString(item.home_scores[1]) + "-" + _toDisplayString(item.away_scores[1]), 1 /* TEXT */),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('match.jiao')) + ":" + _toDisplayString(item.home_scores[4]) + "-" + _toDisplayString(item.away_scores[4]), 1 /* TEXT */),
                                    ($setup.is_has_history && item.zhishu && item.zhishu[1])
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString($setup.getZhishuStr(item.zhishu[1][2])), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true),
                                    (item.away_scores[3] > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(item.away_scores[3]), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true),
                                    (item.away_scores[2] > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(item.away_scores[2]), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true),
                                    _createCommentVNode(" </p> ")
                                  ]))
                                : (item.type_id == 2)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createCommentVNode(" 篮球 "),
                                      _createElementVNode("div", _hoisted_38, [
                                        _createElementVNode("span", null, _toDisplayString($setup.getBasketBallScore(item)), 1 /* TEXT */)
                                      ])
                                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                  : _createCommentVNode("v-if", true)
                            ]),
                            (item.host.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                  _hoisted_40,
                                  (item.host.length > 0)
                                    ? (_openBlock(), _createBlock(_component_van_swipe, {
                                        key: 0,
                                        loop: false
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_van_swipe_item, null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_41, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.host, (items, indexs) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    class: "userList",
                                                    onClick: _withModifiers(($event: any) => ($setup.toLiveRoom(items)), ["stop"]),
                                                    key: indexs
                                                  }, [
                                                    _createElementVNode("img", {
                                                      src: items.portrait
                                                    }, null, 8 /* PROPS */, _hoisted_43),
                                                    _createElementVNode("div", _hoisted_44, _toDisplayString(items.nickName), 1 /* TEXT */)
                                                  ], 8 /* PROPS */, _hoisted_42))
                                                }), 128 /* KEYED_FRAGMENT */))
                                              ])
                                            ]),
                                            _: 2 /* DYNAMIC */
                                          }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1024 /* DYNAMIC_SLOTS */))
                                    : _createCommentVNode("v-if", true)
                                ]))
                              : _createCommentVNode("v-if", true)
                          ])
                        ], 8 /* PROPS */, _hoisted_8))
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["item", "active", "data-index"])
              ]),
              after: _withCtx(() => [
                _createElementVNode("div", _hoisted_45, _toDisplayString($setup.finished && 'No more' || 'Loading...'), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["items"])),
        ($setup.jumpNowDay)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "jumpNowDay",
              style: _normalizeStyle({ bottom: $setup.upNowBottom() }),
              onClick: $setup.jumpNowDayFn
            }, _toDisplayString(_ctx.$t('match.jumpNowDay')), 5 /* TEXT, STYLE */))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "success-text"])
  ]))
}